<template>

  <div class="chart-container">

  <!--<div class="pie-wrapper">
   <PieChart :chart-data="dataTouchdowns" :options="dataOptions2"></PieChart>
  </div>-->

  <div class="wrapper-chart-2col">

    <div class="chart-wrapper">
      <h2 class="chart-headline">COMPLETION %</h2>
      <LineChart :chart-data="dataCompletionPerc" :options="dataOptions2"></LineChart>
    </div>

    <div class="chart-wrapper">
      <h2 class="chart-headline">YARDS PER GAME</h2>
      <LineChart :chart-data="dataYardsPerGame" :options="dataOptions2"></LineChart>
    </div>

    <div class="chart-wrapper">
      <h2 class="chart-headline">TD PASSES</h2>
      <LineChart :chart-data="dataTouchdowns" :options="dataOptions2"></LineChart>
    </div>

   <div class="bubble-chart-wrapper chart-light">
      <h2 class="chart-headline">QB CAREER STATS</h2>
      <BubbleChart :chart-data="dataBubble1" :options="dataOptions3"></BubbleChart>
    </div>

  </div>

</div>

</template>


<script>

// CommitChart.js
import LineChart from './LineChart'
import PieChart from './PieChart'
import BubbleChart from './BubbleChart'

export default {
  components: {
    LineChart,
    PieChart,
    BubbleChart
    },
  data: () => ({ 
      dataCollection: {},
      dataOptions:{}
  }),
  created () {
    this.dataBubble1 = {
      "datasets": [
        {
        "label": "Drew Brees",
        "backgroundColor": "black",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#D3BC8D",
        data: [
                {
                  x: 67.7,
                  y: 80358,
                  r: 571/18
                }
        ]
      },
      {
        "label": "Tom Brady",
        "backgroundColor": "#002244",
        "borderColor": "#C60C30",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 64.0,
                  y: 79204,
                  r: 581/18
                }
              ]
      },
      {
        "label": "Peyton Manning",
        "backgroundColor": "#FB4F14",
        "borderColor": "#024",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.3,
                  y: 71940,
                  r: 539/18
                }
              ]
      },
      {
        "label": "Brett Favre",
        "backgroundColor": "#4F2683",
        "borderColor": "#FFC62F",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 62.0,
                  y: 71838,
                  r: 508/18
                }
              ]
      },
      {
        "label": "Dan Marino",
        "backgroundColor": "#008E97",
        "borderColor": "#F26A24",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 59.4,
                  y: 61361,
                  r: 420/18
                }
              ]
      },
      {
        "label": "Aaron Rodgers",
        "backgroundColor": "#203731",
        "borderColor": "#FFB612",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 65.1,
                  y: 51245,
                  r: 412/18
                }
              ]
      },
      {
        "label": "John Elway",
        "backgroundColor": "#001489",
        "borderColor": "#FA4616",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 56.9,
                  y: 51475,
                  r: 300/18
                }
              ]
      },
      {
        "label": "Joe Montana",
        "backgroundColor": "#AA0000",
        "borderColor": "#B3995D",
        "fill": false,
        "pointRadius": 7,
        hoverRadius: 0,
        borderWidth: 3,
        hoverBorderWidth:3,
        "pointHighlightFill": "#C60C30",
        data: [
                {
                  x: 63.2,
                  y: 40551,
                  r: 273/18
                }
              ]
      }
      ]
    },
    this.dataCompletionPerc = {
      "labels": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
      "datasets": [{
        "label": "Drew Brees",
        "backgroundColor": "#D3BC8D",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        "pointRadius": 5,
        "pointHoverRadius": 10,
        "pointHighlightFill": "#D3BC8D",
        "data": [55.6, 60.8, 57.6, 65.5, 64.6, 64.3, 67.5, 65.0, 70.6, 68.1, 71.2, 63.0, 68.6, 69.2, 68.3, 70.0, 72.0, 74.4, 74.3, 70.5]
      },
      {
        "label": "League AVG",
        "borderColor": "#E1DEE3",
        "backgroundColor": "#E1DEE3",
        "fill": false,
        "pointBackgroundColor": '#E1DEE3',
        "strokeColor": "rgba(146,146,146,1)",
        "pointColor": "rgba(146,146,146,1)",
        "pointRadius": 5,
        "pointHoverRadius": 10,
        "data": [59.0, 59.6, 58.8, 59.8, 59.5, 59.8, 61.2, 61.0, 60.9, 60.8, 60.1, 60.9,  61.2, 62.6, 63.0, 63.0, 62.1, 65.1, 63.5, 65.2]
      }]
    },

    this.dataYardsPerGame = {
      "labels": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
      "datasets": [{
        "label": "Drew Brees",
        "backgroundColor": "#D3BC8D",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        "pointRadius": 5,
        "pointHoverRadius": 10,
        "pointHighlightFill": "#D3BC8D",
        "data": [221.0, 205.3, 191.6, 210.6, 223.5, 276.1, 276.4, 316.8, 292.5, 288.8, 342.3, 323.6, 322.6, 309.5, 324.7, 325.5, 270.9, 266.1, 270.8, 245.2]
      },
      {
        "label": "League AVG",
        "backgroundColor": "#E1DEE3",
        "borderColor": "#E1DEE3",
        "fill": false,
        "pointBackgroundColor": '#E1DEE3',
        "strokeColor": "rgba(146,146,146,1)",
        "pointColor": "rgba(146,146,146,1)",
        "pointRadius": 5,
        "pointHoverRadius": 10,
        "data": [205.8, 212.2, 200.4, 210.5, 203.5, 204.8, 214.3, 211.3, 218.5, 221.6, 229.7, 231.3,  235.6, 236.8, 243.8, 241.5, 224.4, 252.2, 235, 240.2]
      }]
    },

        this.dataTouchdowns = {
      "labels": ["2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
      "datasets": [{
        "label": "Drew Brees",
        "backgroundColor": "#D3BC8D",
        "borderColor": "#D3BC8D",
        "fill": false,
        "pointBackgroundColor": '#D3BC8D',
        "pointColor": "#D3BC8D",
        "pointRadius": 5,
        "pointHoverRadius": 10,
        "pointHighlightFill": "#D3BC8D",
        "data": [1, 17, 11, 27, 24, 26, 28, 34, 34, 33, 46, 43, 39, 33, 32, 37, 23, 32, 27, 24]
      },
      {
        "label": "League AVG",
        "backgroundColor": "#E1DEE3",
        "borderColor": "#E1DEE3",
        "fill": false,
        "pointBackgroundColor": '#E1DEE3',
        "strokeColor": "rgba(146,146,146,1)",
        "pointColor": "rgba(146,146,146,1)",
        "pointRadius": 5,
        "pointHoverRadius": 10,
        "data": [20.8, 22.4, 20.8, 22.4, 20.8, 20.8, 22.4, 20.8, 22.4, 24, 24, 24,  25.6, 25.6, 25.6, 24, 22.4, 23.3, 25.6, 27.2]
      }]
    },
    this.dataOptions = {
        "responsive": true,
        "maintainAspectRatio": false,
        "scales": {
          "yAxes": [{
            "ticks": {
              "fontColor": '#fff'
            },
          }],
          "xAxes": [{
            "ticks": {
              "fontColor": '#eaeaea'
            },
          }]
        }
    },
    this.dataOptions2 = {
        "responsive": true,
        "maintainAspectRatio": false,
        "layout": {
          "padding": 0
        },
        "legend": {
            "labels": {
                "fontColor": "white",
                "fontSize": 16,

            }
        },
        "tooltips": {
            "mode": "index"
        },
        "scales": {
          "yAxes": [{
            gridLines: {
          color: '#2b2b2b',
          lineWidth: 1
            },
            "ticks": {
              "fontColor": '#fff'
            },
          }],
          "xAxes": [{
            gridLines: {
          color: '#2b2b2b',
          lineWidth: 1
            },
            "ticks": {
              "fontColor": '#eaeaea',
              "fontSize": 12,
            },
          }]
        }
    },
        this.dataOptions3 = {
        "responsive": true,
        "maintainAspectRatio": false,
        title: {
            display: true,
            text: '(Bubble size is touchdowns)'
        },
        "layout": {
          padding: {
                left: 5,
                right: 5,
                top: 0,
                bottom: 0
          },
        },
        "legend": {
          "position" : "bottom",
            "maxSize" : {
                "height" : 200
            },
            "labels": {
                "fontColor": "black",
                "fontSize": 14,
                "usePointStyle" : true
            }
        },
        tooltips: {
          "mode": "point",
          callbacks: {
              label: function(tooltipItem, data) {
                 var rLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].r;
                  var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                  return datasetLabel + ' : ' + tooltipItem.xLabel + ' Completion%, ' + tooltipItem.yLabel.toLocaleString() + ' Yards, ' + rLabel*18 + ' TDs';
              }
          }
        },
        "scales": {
          "yAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Yards'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
                },
            "ticks": {
              "fontColor": 'black',
              callback: function(value, index, values) {
                        return value.toLocaleString();
                    },
            },
          }],
          "xAxes": [{
            scaleLabel: {
              display: true,
              labelString: 'Completion Percentage'
            },
            gridLines: {
              color: '#D3BC8D',
              tickMarkLength: 20,
              lineWidth: .2
            },
            "ticks": {
              callback: function(value, index, values) {
                        return value + '%';
                    },
              "fontColor": 'black'
            },
          }]
        }
    }
    
  }
}

</script>

<style scoped>

.chart-container {
  width: 100%;
  margin: 20px auto;
  background:#1d1d1d;
  text-align:  center;
  color: #fff;
}

.wrapper-chart-2col {
    display: flex;
    flex-wrap:wrap;
    justify-content:space-around;
}

.chart-wrapper {
    width: 47%;
    border: 10px solid white;
    margin-bottom: 30px;
}

h2.chart-headline {
    font-size: 40px;
    padding: 5px 20px;
    margin-top:0px;
     margin-bottom:0px;
    background: linear-gradient(180deg,#dbcf9b 0,#d3bc8d 50%,#bfa980 51%,#d3bc8d);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#dbcf9b",endColorstr="#d3bc8d",GradientType=0);
}


.bubble-chart-wrapper  {
  width:100%!important;
  max-width:100%!important;
}

.chart-light {
    background: white;
}



@media (max-width:1366px) {

}

@media (max-width:1023px) {

.chart-wrapper  {
    width: 98%;
    border: 5px solid white;
    border-left:none;
    border-right:none;
}

h2.chart-headline {
    font-size: 24px;
    padding: 5px 10px;
}

}

@media (max-width:767px) {

}

@media (max-width:420px) {

}

.p {
  text-align: center;
  font-size: 12px;
  padding-top: 140px;
}

</style>


// WEBPACK FOOTER //
// src/components/TDsChart.vue